var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 11.3L9.7 5.3C9.3 4.9 8.7 4.9 8.3 5.3C7.9 5.7 7.9 6.3 8.3 6.7L13.6 12L8.3 17.3C7.9 17.7 7.9 18.3 8.3 18.7C8.5 18.9 8.7 19 9 19C9.3 19 9.5 18.9 9.7 18.7L15.7 12.7C16.1 12.3 16.1 11.7 15.7 11.3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconChevronRight.507d467481219af6785d987efc22d512.svg";